import { Component, createRef } from 'preact';
import ClassNames from "classnames";
import PickupLocationMapForm from "../../pickup/modal/map/PickupLocationMapForm";
import { createFocusTrap } from "../../util/KeyboardNavigationUtils";

export default class SimpleMapModal extends Component {

    constructor(props) {
        super(props);
        this.modalRef = createRef();
        this.focusTrap = null;
    }

    componentDidMount() {
        this.handleOpenChange(false, this.props.open);
        if (this.props.open) {
            this.setupFocusTrap();
        }
    }

    componentDidUpdate(prevProps) {
        this.handleOpenChange(prevProps.open, this.props.open);
        if (!prevProps.open && this.props.open) {
            this.setupFocusTrap();
        } else if (prevProps.open && !this.props.open) {
            this.removeFocusTrap();
        }
    }

    componentWillUnmount() {
        this.handleOpenChange(this.props.open, false);
        this.removeFocusTrap();
    }

    handleOpenChange = (wasOpen, isOpen) => {
        if (!wasOpen && isOpen) {
            document.addEventListener('keydown', this.handleEscapeKey);
        } else if (wasOpen && !isOpen) {
            document.removeEventListener('keydown', this.handleEscapeKey);
        }
    };

    closeModal = () => {
        this.props.toggleMapModal(false);
    };

    handleEscapeKey = (event) => {
        if (event.key === 'Escape') {
            this.closeModal();
        }
    };

    preventScroll = (e) => {
        e.preventDefault();
        e.stopPropagation();
    };

    /**
     * Stub for unused callbacks.
     */
    noop = () => {};

    setupFocusTrap = () => {
        if (!this.focusTrap && this.modalRef.current) {
            this.focusTrap = createFocusTrap(this.modalRef.current);
            this.focusTrap.activate();
        }
    };

    removeFocusTrap = () => {
        if (this.focusTrap) {
            this.focusTrap.deactivate();
            this.focusTrap = null;
        }
    };

    render() {
        const {pickupLocation, open, isStorePickup, storeLogo, config} = this.props;

        const modalClassName = ClassNames("pickup-select__modal modal", {open});
        const pickupLocations = pickupLocation ? [pickupLocation] : [];
        const closeButtonStyle = "LIGHT_GREEN" === config.style ? "window__close window__close-brown" : "window__close";

        return (
            <aside ref={this.modalRef} className={modalClassName} aria-modal="true" aria-hidden="true" id="simple-map" onScroll={this.preventScroll} onTouchMove={this.preventScroll}>
                <div className="modal__container">
                    <section className="window">

                        <PickupLocationMapForm pickupLocations={pickupLocations}
                                               open={open}
                                               onSelectPickupLocation={this.noop}
                                               isStorePickup={isStorePickup}
                                               storeLogo={storeLogo}
                                               config={config}
                                               simple/>

                        <button className={closeButtonStyle} onClick={this.closeModal}>
                            Close
                        </button>
                    </section>
                </div>
            </aside>
        );
    }
}
